define(function (require) {
    "use strict";
    var LE = require("app");
    var template = require("user-management-templates/skills/accountSettingsAutoCloseOptionBubbleView.tmpl");
    var TimeUtilities = require("utils/TimeUtilities");

    var AccountSettingsAutoCloseOptionBubbleView = {};

    LE.module("LEUserManagement", function (LEUserManagement, LE, Backbone, Marionette, $, _) {
        AccountSettingsAutoCloseOptionBubbleView = Marionette.ItemView.extend({
            template: template,
            ui: {},
            initialize: function(options) {

            },

            customTemplateHelpers: function() {
                var autoCloseSiteSettings = LEUserManagement.getDataManager().getSiteSettingsAutoClose();
                var autoCloseInSeconds = autoCloseSiteSettings && autoCloseSiteSettings.getValue();

                var autoCloseValue = TimeUtilities.convertSecondsToOtherUnit(autoCloseInSeconds);
                var unit = TimeUtilities.getTranslatedUnit(autoCloseValue.unit);

                return {
                    autoCloseValue: autoCloseValue.time,
                    autoCloseUnit: unit
                };
            },
            onClose: function() {
                LEUserManagement.logger.debug("onClose", "AccountSettingsAutoCloseOptionBubbleView:onClose");
            }
        });
    });
    return AccountSettingsAutoCloseOptionBubbleView;
});
